import React, { Component } from 'react'

import Auth from 'j-toker'
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga'
import {
  Redirect,
  Router,
  Route,
  Switch,
} from 'react-router-dom'

import './App.css'

import { trackPage } from './app/utilities/analytics'

import componentAsync from './app/components/component-async'
import ComponentScrollToTop from './app/components/component-scroll-to-top'
import RoutePrivate from './app/components/routes/route-private'
import RoutePublic from './app/components/routes/route-public'

import FooterSite from './app/components/footers/footer-site'
import HeaderSite from './app/components/headers/header-site'

const HeaderStories  = componentAsync(() => import('./app/pages/stories/organisms/header-stories'))

const AdsNew  = componentAsync(() => import('./app/pages/ads/templates/ads-new'))
const AdsStatus  = componentAsync(() => import('./app/pages/ads/templates/ads-status'))

const JobsIndex  = componentAsync(() => import('./app/pages/jobs/templates/jobs-index'))
const JobsNew  = componentAsync(() => import('./app/pages/jobs/templates/jobs-new'))
const JobsStatus  = componentAsync(() => import('./app/pages/jobs/templates/jobs-status'))

const StaticUnmatched  = componentAsync(() => import('./app/pages/static/templates/static-unmatched'))
const StaticAbout  = componentAsync(() => import('./app/pages/static/templates/static-about'))

const StoriesIndex  = componentAsync(() => import('./app/pages/stories/templates/stories-index'))
const StoriesNew  = componentAsync(() => import('./app/pages/stories/templates/stories-new'))
const StoriesShow  = componentAsync(() => import('./app/pages/stories/templates/stories-show'))

const ShowOfTheWeekNew  = componentAsync(() => import('./app/pages/show_of_the_weeks/templates/show-of-the-week-new'))

const UserEdit  = componentAsync(() => import('./app/pages/user/templates/user-edit'))
const UserNew  = componentAsync(() => import('./app/pages/user/templates/user-new'))
const UserNotifications  = componentAsync(() => import('./app/pages/user/templates/user-notifications'))
const UserSelf  = componentAsync(() => import('./app/pages/user/templates/user-self'))
const UserShow  = componentAsync(() => import('./app/pages/user/templates/user-show'))
const UserPasswordReset  = componentAsync(() => import('./app/pages/user/templates/user-password-reset'))
const UserRecover  = componentAsync(() => import('./app/pages/user/templates/user-recover'))

const history = createHistory();

class App extends Component {
  componentDidMount() {
    ReactGA.initialize('UA-32325919-8');
    trackPage(window.location.pathname);
    this.triggerLogin();
    history.listen((location, action) => {
      trackPage(location.pathname);
      this.triggerLogin();
    });
  }

  triggerLogin() {
    if(window.location.search.includes('login')) {
      window.dispatchEvent(new Event('toggleLogin'));
    }
  }

  render() {
    return (
      <Router history={history}>
        <ComponentScrollToTop>
          <div className="app">
            <HeaderSite/>
            <main role="main" className="page-content">
              <Switch>
                <Route path="/" exact component={HeaderStories} />
                <Route path="/newest" exact component={HeaderStories} />
                <Route path="/shows" exact component={HeaderStories} />
                <Route path="/badges/:filter_tag" exact component={HeaderStories} />
                <Route path="/stories/new" exact component={null} />
                <Route path="/stories/:story_slug" exact component={null} />
              </Switch>
              <Switch>
                {/* Stories */}
                <Route path="/" exact component={StoriesIndex} />
                <Route path="/newest" exact component={StoriesIndex}/>
                <Route path="/shows" exact component={StoriesIndex}/>
                <Redirect path="/badges/show" to={`/shows`} />
                <Route path="/badges/:filter_tag" exact component={StoriesIndex} />
                <RoutePrivate path="/stories/new" exact component={StoriesNew} />
                <Route path="/stories/:story_slug" exact component={StoriesShow} />

                {/* Jobs */}
                <Route path="/jobs" exact component={JobsIndex} />
                <Route path="/jobs/new" exact component={JobsNew} />
                <Route path="/jobs/:job_listing_key/status" exact component={JobsStatus} />

                {/* Show of the week */}
                <RoutePrivate path="/podcast-of-the-week/new" exact component={ShowOfTheWeekNew} />

                {/* Sponsored Post */}
                <Route path="/sponsor/new" exact component={AdsNew} />
                <Route path="/sponsor/:ad_listing_key/status" exact component={AdsStatus} />

                {/* Account */}
                <RoutePrivate path="/account" exact component={UserSelf}/>
                <RoutePublic path="/account/sign-up" exact component={UserNew}/>
                <RoutePrivate path="/account/notifications" exact component={UserNotifications}/>
                <RoutePrivate path="/account/edit" exact component={UserEdit}/>
                <RoutePublic path="/account/recover" exact component={UserRecover}/>
                <Route path="/account/reset-password" exact component={UserPasswordReset}/>


                {/* User */}
                <Route path="/users/:user_key" exact component={UserShow}/>

                {/* Static */}
                <Route path="/about" exact component={StaticAbout} />
                <Route component={StaticUnmatched}/>
              </Switch>
            </main>
            <FooterSite />

          </div>
        </ComponentScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js